import React from 'react';
import BrandRuleEditor from './BrandRuleEditor';

const BrandDisallowlist = () => (
  <BrandRuleEditor ruleType='brand_disallowlist' label='Forbidden brands' />
);

export default BrandDisallowlist;
